<div [ngClass]="'form-editor'">
    <dx-select-box [attr.id]="'input-' + element.ElementID" [dataSource]="itemsDataSource" [acceptCustomValue]="true" displayExpr="DisplayName" [value]="selectedItem" [disabled]="inputFormGroup.get('value')?.disabled"
                   [maxLength]="element.MaxLength"
                   [showClearButton]="true" (onCustomItemCreating)="onCustomItemCreate($event)" (onSelectionChanged)="changeComboBoxEditValue($event)"
                   [(isValid)]="renderingInformation.validationInformation.valid"
                   [(validationError)]="renderingInformation.validationInformation.validationMessage"
                   [placeholder]="element.NullText ?? ''">
    </dx-select-box>
</div>
